<template>
  <div
    class="flex items-center p-4 cursor-pointer ml-auto"
    @click="toggleFavourite"
  >
    Favourite
    <ion-icon :name="starIcon" class="fs-3 ml-1"></ion-icon>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import { TOGGLE_FAVOURITE } from "@/store/types/mutations";

export default {
  name: "ToggleFavourite",
  props: {
    numUriString: String,
  },
  computed: {
    ...mapState(["favourites"]),
    starIcon() {
      return this.isFavourite ? "star-sharp" : "star-outline";
    },
    isFavourite() {
      return this.favourites.some(f => f.numUriString === this.numUriString);
    },
  },
  methods: {
    ...mapMutations([TOGGLE_FAVOURITE]),
    toggleFavourite() {
      this.TOGGLE_FAVOURITE(this.numUriString);
    },
  },
};
</script>
